import { Injectable } from "@angular/core";
import { AvailabilityService } from "./availability.service";
import { NotificationService } from "./notification.service";
import { Instructor, User } from "../models";

@Injectable({ providedIn: "root" })
export class ReservationConflictService {
  constructor(
    private availability: AvailabilityService,
    private notifier: NotificationService
  ) {}

  /**
   * À appeler juste après la création/modification d'une réservation.
   * Envoie un mail à l'instructeur si le créneau chevauche une indispo
   * et si le créateur n'est PAS l'instructeur.
   */
  async handlePostSaveNotification(args: {
    instructor: Instructor | null | undefined;
    currentDate: Date;
    startMin: number;
    endMin: number;
    openHour: number;
    closeHour: number;
    creatorUser: User | null | undefined;
    aircraftCode?: string; // optionnel, si tu l’as sous la main
  }): Promise<void> {
    const {
      instructor,
      currentDate,
      startMin,
      endMin,
      openHour,
      closeHour,
      creatorUser,
      aircraftCode,
    } = args;

    if (!instructor) return;

    // si le créateur est l'instructeur → pas de notif
    const instrUserId = instructor.user?.id;
    const creatorId = creatorUser?.id;
    if (instrUserId && creatorId && instrUserId === creatorId) return;

    // overlap en minutes avec les indispos
    const overlap = this.availability.overlapWithUnavailability(
      instructor,
      currentDate,
      startMin,
      endMin,
      openHour,
      closeHour
    );
    if (overlap <= 0) return;

    // formate ISO
    const startISO = isoAtMinutes(currentDate, startMin);
    const endISO = isoAtMinutes(currentDate, endMin);

    // envoi (fire-and-forget)
    this.notifier
      .notifyInstructorConflict({
        instructorId: instructor.id,
        instructorEmail: instructor.user?.email,
        dateISO: new Date(currentDate).toISOString(),
        startISO,
        endISO,
        aircraftCode,
        createdByName: (
          creatorUser?.lastname ??
          creatorUser?.email ??
          "Utilisateur"
        ).toString(),
      })
      .subscribe({ error: () => {} });
  }
}

/** petit helper local sans dépendance Angular */
function isoAtMinutes(date: Date, minutes: number): string {
  const d = new Date(date);
  d.setHours(Math.floor(minutes / 60), minutes % 60, 0, 0);
  return d.toISOString();
}
